export default "__VITE_ASSET__BbidKxiw__"